export default "__VITE_ASSET__2216e9da__"